import styled from 'styled-components';
import { Dialog } from 'primereact/dialog';

// Currently, the theme applies some undesired paddings
// which clash with the design in Figma
const DialogClearStyles = styled(Dialog)`
  border: none;

  && .p-dialog-header {
    padding: 0;
  }
  && .p-dialog-title {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
export default DialogClearStyles;

export const DialogClearStylesButtonsFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const DialogContent = styled.div`
  width: 90vw;
  max-width: 560px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
`;

export const InputsContainer = styled.div`
  display: grid;
  gap: 30px;
`;

export const DialogFooter = styled.div`
  margin-top: 30px;
`;